import {
  GET_GUEST_ORDER_HISTORY_DETAILS_PENDING,
  GET_GUEST_ORDER_HISTORY_DETAILS_FULFILLED,
  GET_GUEST_ORDER_HISTORY_DETAILS_FAILED,
} from "constants-lib/actionTypes"

import { API_STATUSES } from "constants-lib/common"

export const initialState = {
  orderDetails: {},
  orderDetailsStatus: "",
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_GUEST_ORDER_HISTORY_DETAILS_PENDING:
      return {
        ...state,
        orderDetails: {},
        orderDetailsStatus: API_STATUSES.PENDING,
      }

    case GET_GUEST_ORDER_HISTORY_DETAILS_FULFILLED:
      return {
        ...state,
        orderDetails: {
          ...action.payload,
        },
        orderDetailsStatus: API_STATUSES.FULFILLED,
      }

    case GET_GUEST_ORDER_HISTORY_DETAILS_FAILED:
      return {
        ...state,
        orderDetails: {},
        orderDetailsStatus: API_STATUSES.FAILED,
      }

    default:
      return state
  }
}
